export default function(value) {
  const len = value

  return len + ' job' + (len !== 1 ? 's' : '')
}
